// extracted by mini-css-extract-plugin
export default {"title":"FeaturedCourses_title__EF9Vl","carousel":"FeaturedCourses_carousel__PeFGK","button":"FeaturedCourses_button__vsdC8"};